'use client';

import { ReactNode } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

if (typeof window !== 'undefined') {
	const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY || '';
	const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST || '';

	posthog.init(posthogKey!, {
		api_host: posthogHost,
		person_profiles: 'always', // or 'always' to create profiles for anonymous users as well
	});
}

interface CSPostHogProviderProps {
	children: ReactNode;
}

export function CSPostHogProvider({ children }: CSPostHogProviderProps) {
	const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY || '';
	const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST || '';

	return (
		<PostHogProvider
			apiKey={posthogKey}
			options={{
				api_host: posthogHost,
				person_profiles: 'always',
			}}
		>
			{children}
		</PostHogProvider>
	);
}
